import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Modal, inp, lbl } from "./GearBits";

/* Reuse a bag for another trip: pick which of its items travel again. */
export default function ReuseBagModal({ bag, items, trips, onDone, onClose }) {
  const bagItems = items.filter((i) => i.bag_id === bag.id);
  const [tripId, setTripId] = useState("");
  const [picked, setPicked] = useState(Object.fromEntries(bagItems.map((i) => [i.id, true])));
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true);
    try {
      const item_ids = bagItems.filter((i) => picked[i.id]).map((i) => i.id);
      const { data } = await api.post(`/gear/bags/${bag.id}/reuse`, { trip_id: tripId || null, item_ids });
      toast.success(`Bag ready for the new trip — ${data.items_kept} items reset to "not packed"`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not reuse bag"); }
    finally { setBusy(false); }
  };

  return (
    <Modal title={`Reuse "${bag.name}" for another trip`} onClose={onClose}>
      <div className="space-y-4" data-testid="reuse-bag-modal">
        <div><label className={lbl}>New trip</label>
          <select value={tripId} onChange={(e) => setTripId(e.target.value)} data-testid="reuse-trip" className={inp}>
            <option value="">— No trip / just reset —</option>
            {trips.map((t) => <option key={t.id} value={t.id}>{t.title}</option>)}
          </select></div>

        <div>
          <div className={lbl}>Which items travel again? (unticked items leave the bag)</div>
          {bagItems.length === 0 ? (
            <p className="text-sm text-muted-foreground">This bag has no items yet.</p>
          ) : (
            <div className="max-h-56 overflow-y-auto border border-zinc-200 divide-y divide-zinc-100" data-testid="reuse-items">
              {bagItems.map((i) => (
                <label key={i.id} className="flex items-center gap-2 p-2.5 text-sm cursor-pointer hover:bg-zinc-50">
                  <input type="checkbox" checked={!!picked[i.id]} onChange={() => setPicked({ ...picked, [i.id]: !picked[i.id] })} className="w-4 h-4 accent-primary" />
                  {i.name} {i.quantity > 1 && <span className="text-xs text-muted-foreground">×{i.quantity}</span>}
                </label>
              ))}
            </div>
          )}
        </div>

        <button onClick={go} disabled={busy} data-testid="reuse-confirm"
          className="w-full py-2.5 text-sm font-bold bg-primary text-white hover:bg-blue-700 disabled:opacity-50">
          {busy ? "Updating…" : "Reuse bag — reset packing"}
        </button>
      </div>
    </Modal>
  );
}
